// extracted by mini-css-extract-plugin
export default {"UserSetting":"UserSetting_UserSetting__ybFcR","UserSetting__Change-PWD":"UserSetting_UserSetting__Change-PWD__fDbbP"};